import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogModal : {isOpen: false, activeObject:null},
  statModal : {isOpen: false, activeObject:null},
  articleModal : {isOpen: false, activeObject:null},
  blogModal : {isOpen: false, activeObject:null},
  hiringModal : {isOpen: false, activeObject:null},
  hiringContactModal : {isOpen: false, activeObject:null},
  hiringContactFormModal : {isOpen: false, activeObject:null},
  awardModal : {isOpen: false, activeObject:null},
  toolboxModal : {isOpen: false, activeObject:null},
  videoModal : {isOpen: false, activeObject:null},
  paramModal : {isOpen: false, activeObject:null},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    /* Modal */
    openModal: (state, action) => {
      state.dialogModal = {isOpen : true, activeObject : action.payload};
    },
    closeModal: (state, action) => {
      state.dialogModal = {isOpen : false, activeObject :null, isReadOnly : null};
    },
    /* Stat Modal */
    openModalStat: (state, action) => {
      state.statModal = {isOpen : true, activeObject : action.payload.stat_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalStat: (state, action) => {
      state.statModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Article Modal */
    openModalArticle: (state, action) => {
      state.articleModal = {isOpen : true, activeObject : action.payload.article_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalArticle: (state, action) => {
      state.articleModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Blog Modal */
    openModalBlog: (state, action) => {
      state.blogModal = {isOpen : true, activeObject : action.payload.blog_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalBlog: (state, action) => {
      state.blogModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Hiring Modal */
    openModalHiring: (state, action) => {
      state.hiringModal = {isOpen : true, activeObject : action.payload.hiring_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalHiring: (state, action) => {
      state.hiringModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Hiring Contact Modal */
    openModalHiringContact: (state, action) => {
      state.hiringContactModal = {isOpen : true, activeObject : action.payload.hiring_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalHiringContact: (state, action) => {
      state.hiringContactModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Hiring Contact Form Modal */
    openModalHiringContactForm: (state, action) => {
      state.hiringContactFormModal = {isOpen : true, activeObject : action.payload.hiringContact_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalHiringContactForm: (state, action) => {
      state.hiringContactFormModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },


    /* Award Modal */
    openModalAward: (state, action) => {
      state.awardModal = {isOpen : true, activeObject : action.payload.award_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalAward: (state, action) => {
      state.awardModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Toolbox Modal */
    openModalToolbox: (state, action) => {
      state.toolboxModal = {isOpen : true, activeObject : action.payload.toolboxPartners_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalToolbox: (state, action) => {
      state.toolboxModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Video Modal */
    openModalVideo: (state, action) => {
      state.videoModal = {isOpen : true, activeObject : action.payload.video_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalVideo: (state, action) => {
      state.videoModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },

    /* Params Modal */
    openModalParam: (state, action) => {
      state.paramModal = {isOpen : true, activeObject : action.payload.video_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalParam: (state, action) => {
      state.paramModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },
  },
});

export const {  openModal, closeModal, 
                openModalStat, closeModalStat, 
                openModalArticle, closeModalArticle,
                openModalBlog, closeModalBlog,
                openModalHiring, closeModalHiring,
                openModalHiringContact, closeModalHiringContact,
                openModalHiringContactForm, closeModalHiringContactForm,
                openModalAward, closeModalAward,
                openModalToolbox, closeModalToolbox,
                openModalVideo, closeModalVideo,
                openModalParam, closeModalParam
              } = modalSlice.actions;

export default modalSlice.reducer;
